import { some } from 'es-toolkit/compat';

export function hasSecondaryZipcode(addressesWithCoverage) {
  return some(addressesWithCoverage, (address) => !address.isInPrimaryCoverage);
}
